var swiper = new Swiper(".bundle-products", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

let cartSwiper = new Swiper("[js-cart-upsell]", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const relatedProducts = document.querySelector('.related-products');
if (relatedProducts) {
  relatedProducts.classList.add('hidden');
}

setTimeout(() => {
  const recommendationElement = document.querySelector('.product-recommendations-grid');
  if (recommendationElement) {
    relatedProducts.classList.remove('hidden');

    new Swiper(".product-recommendations-grid", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      slidesPerView: 1,
      spaceBetween: 30,
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      }
    });
  }
}, 2000);

const bundleButtons = document.querySelectorAll('[js-bundle-add-button]');
this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

bundleButtons.forEach(button => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const bundleForms = document.querySelectorAll('[js-bundle-form]');

    bundleForms.forEach(form => {
      const id = form.getAttribute('data-variant-id');

      if (id == button.getAttribute('data-variant-id')) {
        const button = form.querySelector('form .product-form__buttons button');
        if (button) button.click();
      }
    });
  })
});

window.theme = window.theme || {};

window.theme.getGeoCountry = function () {
  return new Promise((resolve) => {
    const cached = localStorage.getItem('geo');
    if (cached) {
      resolve(cached);
      return;
    }
    if (typeof geoip2 === 'undefined') {
      resolve(null);
      return;
    }
    geoip2.country(
      (res) => {
        localStorage.setItem('geo', res.country.iso_code);
        resolve(res.country.iso_code);
      },
      () => resolve(null)
    );
  });
};

function readCartTotalFromDOM() {
  const parent = document.querySelector('.marquee__parent');
  if (!parent || parent.dataset.cartTotal === undefined) return null;
  return Number(parent.dataset.cartTotal);
}

function refreshMarqueeFromServer() {
  return fetch('/cart?section_id=marquee', { cache: 'no-store' })
    .then((r) => r.text())
    .then((html) => {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('.marquee__parent');
      const current = document.querySelector('.marquee__parent');
      if (fresh && current) {
        current.dataset.cartTotal = fresh.dataset.cartTotal || '0';
        current.dataset.cartItemCount = fresh.dataset.cartItemCount || '0';
      }
    })
    .catch(() => {});
}

window.theme.updateShippingProgress = function () {
  if (!window.theme.marquee) return;
  const item = document.querySelector('.marquee__item');
  if (!item) return;
  const span = item.querySelector('span');
  if (!span) return;

  const showItem = () => { item.style.display = 'block'; };

  window.theme.getGeoCountry().then((country) => {
    const isUS = country === 'US';
    const baseMsg = isUS ? theme.marquee.usMsg : theme.marquee.internationalMsg;

    const setBase = () => {
      const baseThreshold = Number(isUS ? theme.marquee.usShippingMin : theme.marquee.intlShippingMin);
      const currencyCode = (document.documentElement.dataset.currency || '').toUpperCase();
      const block = theme.marquee.blocks && theme.marquee.blocks[currencyCode];
      let message;
      if (block) {
        message = block.message;
        if (block.show_price && baseThreshold > 0 && window.EXCHANGE) {
          message += ' ' + window.EXCHANGE.ex(baseThreshold);
        }
      } else if (theme.marquee.enableGeo) {
        message = baseMsg;
      }
      if (message) span.innerHTML = message;
      span.classList.add('shipping-progress-active');
      showItem();
    };

    const wrapper = document.querySelector('.min_shipping_msg');
    const threshold = Number(isUS ? theme.marquee.usShippingMin : theme.marquee.intlShippingMin);

    if (!isUS && theme.marquee.disableIntlProgress) {
      span.innerHTML = theme.marquee.intlAltMsg || 'Fast affordable international shipping!';
      span.classList.add('shipping-progress-active');
      showItem();
      return;
    }

    if (!wrapper || !theme.marquee.enableShippingProgress || !threshold) {
      setBase();
      return;
    }

    const currentCurrency = (document.documentElement.dataset.currency || '').toUpperCase();
    const currentBlock = theme.marquee.blocks && theme.marquee.blocks[currentCurrency];
    if (currentBlock && currentBlock.disable_progress) {
      setBase();
      return;
    }

    const total = readCartTotalFromDOM();
    if (total === null || total <= 0) {
      setBase();
      return;
    }
    if (total >= threshold) {
      span.innerHTML = theme.marquee.unlockedMsg;
    } else {
      const diff = threshold - total;
      const formatted = window.EXCHANGE ? window.EXCHANGE.ex(diff) : '$' + (diff / 100).toFixed(2);
      span.innerHTML = theme.marquee.progressMsg.replace('[amount]', formatted);
    }
    span.classList.add('shipping-progress-active');
    showItem();
  });
};

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    refreshMarqueeFromServer().then(() => window.theme.updateShippingProgress());
  });
}

// Network-level interception: fires reliably even when pub/sub is broken (Rocket Loader, etc.)
(function () {
  const origFetch = window.fetch;
  window.fetch = function () {
    const result = origFetch.apply(this, arguments);
    const arg0 = arguments[0];
    const url = typeof arg0 === 'string' ? arg0 : (arg0 && arg0.url) || '';
    if (url && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      result.then(() => {
        refreshMarqueeFromServer().then(() => window.theme.updateShippingProgress());
      }).catch(() => {});
    }
    return result;
  };
})();

// React to manual currency switches (data-currency attr on <html> changes).
(function () {
  const html = document.documentElement;
  if (!html) return;
  let lastCurrency = html.dataset.currency || '';
  new MutationObserver(() => {
    const current = html.dataset.currency || '';
    if (current !== lastCurrency) {
      lastCurrency = current;
      window.theme.updateShippingProgress();
    }
  }).observe(html, { attributes: true, attributeFilter: ['data-currency'] });
})();

document.addEventListener('DOMContentLoaded', function () {
  if (typeof geoip2 !== 'undefined') {
    geoip2.country(onGeoSuccess, onGeoError);
  } else {
    window.theme.updateShippingProgress();
  }

  function onGeoSuccess(res) {

    if (!localStorage.getItem('saved_currency')) {
      var selected_cur = 'USD';
      if (res.continent.code == 'EU') {
        selected_cur = 'EUR';
      }
      if (res.country.iso_code == 'AU') { selected_cur = 'AUD'; }
      if (res.country.iso_code == 'BR') { selected_cur = 'BRL'; }
      if (res.country.iso_code == 'CA') { selected_cur = 'CAD'; }
      if (res.country.iso_code == 'CH') { selected_cur = 'CHF'; }
      if (res.country.iso_code == 'DK') { selected_cur = 'DKK'; }
      if (res.country.iso_code == 'GB' || res.country.iso_code == 'UK') { selected_cur = 'GBP'; }
      if (res.country.iso_code == 'HK') { selected_cur = 'HKD'; }
      if (res.country.iso_code == 'NO') { selected_cur = 'NOK'; }
      if (res.country.iso_code == 'NZ') { selected_cur = 'NZD'; }
      if (res.country.iso_code == 'SE') { selected_cur = 'SEK'; }
      if (res.country.iso_code == 'ZA') { selected_cur = 'ZAR'; }
      if (res.country.iso_code == 'JP') { selected_cur = 'YEN'; }

      if (selected_cur != 'USD'){document.querySelector('.currency-wrapper [data-cur="' + selected_cur + '"]').click()}
    }

    localStorage.setItem('geo', res.country.iso_code)

    window.theme.updateShippingProgress();
  }

  function onGeoError(res) {
    console.log('Geo error', res)
    window.theme.updateShippingProgress();
  }
});